export function formatPhone(phone: string | number | undefined): string {
  if (!phone) return '';
  const cleaned = phone.toString().replace(/\D/g, '');
  
  // Formato WhatsApp México: 52 + 1 + 10 dígitos = 13 dígitos
  // Ejemplo: 52 1 123 456 7890 -> +52 1 123 456 7890
  if (cleaned.length === 13) {
    return `+${cleaned.slice(0, 2)} ${cleaned.slice(2, 3)} ${cleaned.slice(3, 6)} ${cleaned.slice(6, 9)} ${cleaned.slice(9)}`;
  }
  
  // Formato Internacional con código de país de 2 dígitos (ej. 52) y 10 locales = 12 dígitos
  // Ejemplo: 52 123 456 7890 -> +52 123 456 7890
  if (cleaned.length === 12) {
    return `+${cleaned.slice(0, 2)} ${cleaned.slice(2, 5)} ${cleaned.slice(5, 8)} ${cleaned.slice(8)}`;
  }
  
  // Formato Local México (10 dígitos) -> Le agregamos el +52 por defecto
  // Ejemplo: 123 456 7890 -> +52 123 456 7890
  if (cleaned.length === 10) {
    return `+52 ${cleaned.slice(0, 3)} ${cleaned.slice(3, 6)} ${cleaned.slice(6)}`;
  }

  // Si ya tiene el + o es de otra longitud, solo aseguramos el + inicial
  return cleaned.startsWith('+') ? cleaned : `+${cleaned}`;
}
